import axios from 'axios';

// export const getItemList = (id) => axios.get(`/api/item/list/${id}`);

export const getItemList = (id) => axios.get(`/api/item/list/${id}`);

export const getItemView = (id) => axios.get(`/api/item/view/${id}`);

export const getWclInfo = (id) => axios.get(`/api/item/wclinfo/${id}`);

export const getWclRequestReport = (id) => axios.get(`/api/item/wclreport/${id}`);

export const getWowItemList = () => axios.get('api/item/wowitem');

export const getTodayList = (id) => axios.get(`/api/item/finance/${id}`);

// 이거쓰면 pending이 안됨.. ㅆ..
// export const getWclRequestReport = (param1, param2, param3) => {
//   axios.get('/api/item/wclreport', {
//     params: {
//       code: param1,
//       fightID: param2,
//       rankerName: param3
//     }
//   });
// };